import { FC } from 'react'

const TypingIndicator: FC = () => (
  <div className='lum-typing' role='status' aria-label='AI is typing'>
    <span className='lum-dot' />
    <span className='lum-dot' />
    <span className='lum-dot' />
  </div>
)

export default TypingIndicator
